import { Controller } from '@hotwired/stimulus';

// Post-login modal asking the organization owner to name their organization.
// Submitting saves the name (and reloads to reflect it in the navbar); "later"
// dismisses it through a dedicated endpoint that only clears the prompt flag.
export default class extends Controller {
  static targets = ['form', 'error'];

  static values = { dismissUrl: String };

  submit(event) {
    event.preventDefault();
    this.#hideError();

    this.#send(this.formTarget.action, new FormData(this.formTarget)).then((ok) => {
      // A rejected rename (name too long) used to fail silently: the modal just
      // sat there, and the controller's JSON error branch was dead code.
      if (ok) window.location.reload();
      else this.#showError();
    });
  }

  // "Later" must not touch the name. It used to submit an empty
  // organization[name] through #update, wiping a name set from the admin panel
  // while requires_name_prompt was still true.
  skip(event) {
    if (event) event.preventDefault();

    this.#send(this.dismissUrlValue).then(() => this.#close());
  }

  #close() {
    this.element.remove();
  }

  #showError() {
    if (this.hasErrorTarget) this.errorTarget.hidden = false;
  }

  #hideError() {
    if (this.hasErrorTarget) this.errorTarget.hidden = true;
  }

  #send(url, formData = null) {
    return fetch(url, {
      method: 'PATCH',
      headers: { Accept: 'application/json', 'X-CSRF-Token': this.#csrfToken() },
      body: formData,
    })
      .then((response) => response.ok)
      .catch(() => false);
  }

  #csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }
}
